/* eslint-disable complexity */
/* eslint-disable angular/no-service-method */
angular.module('ecrd.queries').service('QueriesListUtilities', [
    '$window',
    'ShareCrfSDK',
    'ShareCrfApiOdataParser',
    'CoreCRF',
    'gettextCatalog',
    'queriesFieldValueFilter',
    'UNKNOWN_VALUE',
    'UnknownService',
    function($window, ShareCrfSDK, ShareCrfApiOdataParser, CoreCRF, gettextCatalog, queriesFieldValueFilter, UNKNOWN_VALUE, UnknownService) {
        function _slugify(input) {
            // make lower case and trim
            var slug = input.toLowerCase().trim();
            // replace invalid chars with spaces
            slug = slug.replace(/[^a-z0-9\s-]/g, ' ');
            // replace multiple spaces or hyphens with a single hyphen
            slug = slug.replace(/[\s-]+/g, '-');

            return slug;
        }
        function getRowData(data, attribute) {
            return angular.isArray(attribute)
                // el valor de la celda se construye a partir de más de un dato
                ? attribute.map(function(attr) {
                    return $window._.get(data, attr);
                })
                : $window._.get(data, attribute);
        }

        var QueriesListUtilities = {};

        QueriesListUtilities.getDiffDays = function(dateA, dateB) {
            var momentA = $window.moment(dateA).startOf('day');
            var momentB = (dateB ? $window.moment(dateB) : $window.moment()).startOf('day');

            return Math.abs(momentA.diff(momentB, 'days'));
        };
        QueriesListUtilities.parseTableSettings = function(settings) {
            var filters = [];
            var order = '';

            if (settings.filters.recordUid) {
                filters.push('contains(recordUid, ' + ShareCrfApiOdataParser.cleanValue(settings.filters.recordUid) + ')');
            }
            if (settings.filters.field) {
                filters.push('fieldUid eq ' + ShareCrfApiOdataParser.cleanValue('' + settings.filters.field.id));
            }
            if (settings.filters.text) {
                filters.push('contains(text, ' + ShareCrfApiOdataParser.cleanValue(settings.filters.text) + ')');
            }
            if (settings.filters.creatorFullname) {
                filters.push('contains(creatorFullname, ' + ShareCrfApiOdataParser.cleanValue(settings.filters.creatorFullname) + ')');
            }
            if (settings.filters.status) {
                if (settings.filters.status === 'closed') {
                    filters.push('status eq ' + ShareCrfApiOdataParser.cleanValue(settings.filters.status));
                }
                else if (settings.filters.status === 'open') {
                    if (settings.filters.substatus) {
                        filters.push('status eq ' + ShareCrfApiOdataParser.cleanValue(settings.filters.substatus));
                    } else {
                        filters.push('status ne ' + ShareCrfApiOdataParser.cleanValue('closed'));
                    }
                }
            }
            if (settings.filters.type) {
                filters.push('type ' + (settings.filters.type === 'manual' ? 'eq ' : 'ne ') + ShareCrfApiOdataParser.cleanValue('manual'));
            }
            if (settings.filters.inSite === true || settings.filters.inSite === false) {
                filters.push('inSite eq ' + ShareCrfApiOdataParser.cleanValue(settings.filters.inSite));
            }
            if (settings.filters.siteCode) {
                filters.push('siteCode eq ' + ShareCrfApiOdataParser.cleanValue(settings.filters.siteCode));
            }

            if (settings.orderBy) {
                order = settings.orderBy + ' ' + (settings.orderReverse ? 'desc' : 'asc');
            }

            var params = {
                limit: settings.limit,
                offset: settings.currentPage * settings.limit,
            };
            if (filters.length) {
                params.filters = filters.join(' and ');
            }
            if (order) {
                params.order = order;
            }

            return params;
        };
        QueriesListUtilities.list = function(params) {
            return ShareCrfSDK.queries.table(params);
        };

        QueriesListUtilities.downloadExcel = function(tableSettings, columns, title) {
            var parameters = QueriesListUtilities.parseTableSettings(tableSettings);
            parameters.limit = null; // download all
            parameters.offset = 0;

            var unknownConfig = UnknownService.getConfig();

            return QueriesListUtilities.list(parameters)
                .then(function(result) {
                    var XLSX = $window.XLSX;
                    var workbook = XLSX.utils.book_new();

                    var col, row, cellRef;
                    var columnWidth = [];
                    var headers = columns.map(function(column, index) {
                        columnWidth[index] = Math.max(columnWidth[index] || 0, column.header.length);

                        return column.header;
                    });
                    var worksheet = XLSX.utils.aoa_to_sheet([headers]);
                    for (col = 0; col < headers.length; col++) {
                        cellRef = XLSX.utils.encode_cell({  /* eslint-disable id-length */
                            c: col,
                            r: 0,
                        });
                        if (worksheet[cellRef]) {
                            worksheet[cellRef].z = '@';
                        }
                    }

                    var data;
                    angular.forEach(result.rows, function(row) {
                        data = [];
                        angular.forEach(columns, function(column, index) {
                            var value = getRowData(row, column.id);
                            if (value && value.value && value.value === UNKNOWN_VALUE) {
                                value = unknownConfig.label;
                            }
                            else if (angular.isFunction(column.formatter)) {
                                value = column.formatter(value);
                            }
                            data.push(value);
                            var length = value ? String(value).length : 1;
                            columnWidth[index] = Math.max(columnWidth[index] || 0, length);
                        });
                        XLSX.utils.sheet_add_aoa(worksheet, [data], { origin: -1 });
                    });
                    var range = XLSX.utils.decode_range(worksheet['!ref']);
                    for (col = 0; col < headers.length; col++) {
                        if (columns[col].type === 'string' || columns[col].type === 'boolean') {
                            for (row = 1; row <= range.e.r; row++) {
                                cellRef = XLSX.utils.encode_cell({ /* eslint-disable id-length */
                                    c: col,
                                    r: row,
                                });
                                if (worksheet[cellRef]) {
                                    worksheet[cellRef].t = 's';
                                    worksheet[cellRef].z = '@';
                                }
                            }
                        } else if (columns[col].type === 'date') {
                            for (row = 1; row <= range.e.r; row++) {
                                cellRef = XLSX.utils.encode_cell({ /* eslint-disable id-length */
                                    c: col,
                                    r: row,
                                });
                                if (worksheet[cellRef]) {
                                    worksheet[cellRef].z = 'dd/mm/yyyy hh:mm:ss';
                                }
                            }
                        }
                    }
                    worksheet['!cols'] = columnWidth.map(function(width) {
                        return { wch: Math.min(width ? width : 0, 40) };
                    });
                    XLSX.utils.book_append_sheet(workbook, worksheet, title);
                    XLSX.writeFile(workbook, _slugify(title) + '.xlsx');
                });
        };

        // GARU-6077 Texto largo por defecto
        QueriesListUtilities.buildFullSummary = function(text, truncate) {
            var summary;

            switch (text) {
                case 'field-required-value-not-specified':
                    summary = gettextCatalog.getString('El campo es obligatorio pero no se ha especificado ningún valor');
                    break;

                case 'closed-by-rule':
                    summary = gettextCatalog.getString('Cerrada por regla automática');
                    break;

                case 'field-required-has-value':
                    summary = gettextCatalog.getString('El campo obligatorio ya tiene un valor');
                    break;

                case 'field-required-no-longer-required':
                    summary = gettextCatalog.getString('El campo ha dejado de ser obligatorio');
                    break;

                case 'field-required-record-state-unset':
                    summary = gettextCatalog.getString('Se ha anulado el estado global');
                    break;

                case 'field-required-form-state-unset':
                    summary = gettextCatalog.getString('Se ha anulado el estado del formulario');
                    break;

                default:
                    if (truncate) {
                        summary = $window._(text).split('\n').truncate({
                            length: 90,
                            separator: /[, \t]+/g,
                        });
                    } else {
                        summary = text;
                    }
            }

            return summary;
        };
        // Para el frontend, el texto de la query se trunca
        QueriesListUtilities.buildSummary = function(text) {
            return QueriesListUtilities.buildFullSummary(text, true);
        };

        // Source: http://stackoverflow.com/a/22535765
        function stripTags(input, allowed) {
            if (!input) return input;
            allowed = (((allowed || '') + '')
                .toLowerCase()
                .match(/<[a-z][a-z0-9]*>/g) || [])
                .join(''); // making sure the allowed arg is a string containing only tags in lowercase (<a><b><c>)
            var tags = /<\/?([a-z][a-z0-9]*)\b[^>]*>/gi,
                commentsAndPhpTags = /<!--[\s\S]*?-->|<\?(?:php)?[\s\S]*?\?>/gi;

            return input.replace(commentsAndPhpTags, '')
                .replace(tags, function(match0, match1) {
                    return allowed.indexOf('<' + match1.toLowerCase() + '>') > -1 ? match0 : '';
                });
        }
        QueriesListUtilities.formatValue = function(value) {
            var formatted;
            if (value.type === 'files') {
                // No usamos el filtro, que acaba usando un $sce complejo de manejar
                formatted = value.value.map(function(file) {
                    return file.filename;
                });

                return formatted.join(', ');
            }

            // GARU-8888 Formatear el valor del campo DICOM en la exportacion de queries
            if (value.type === 'dicom') {
                var dicomValue = value.value;

                if (dicomValue.length > 0) {
                    formatted = dicomValue.map(function(file) {
                        return file.filename.replace(/.zip/, '');
                    });

                    return formatted.join(', ');
                }

                return dicomValue.filename.replace(/.zip/, '');
            }

            formatted = queriesFieldValueFilter(value);
            if (value.type === 'longtext') {
                formatted = formatted.replace(/<br>/g, '\n');
            }

            return stripTags(formatted);
        };

        QueriesListUtilities.getFieldType = function(fieldUId) {
            var field = CoreCRF.getElementByUID(fieldUId);

            return field ? field.getFormControl() : 'unknown';
        };

        return QueriesListUtilities;
    },
]);
